import React from "react"
import "./index.css"
import Nav from "../../components/nav"
import Footer from "../../components/footer"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"
import Helmet from "react-helmet"
import Modal from "../../components/add-order-modal"
import SweetAlert from "../../components/custom-sweetalert"
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

const PanelView = props =>
  !props.initializing && (
    <div className={"panel"}>
      <Helmet>Orders | {process.env.REACT_APP_NAME}</Helmet>
      <Nav logOut={props.logOut} user={props.user} />

      <Container className={"mt-5 pb-5"}>
      <div class="alert alert-primary" role="alert">
 This panel is still in development, if you face any issues please report it by joining our <a href="#" class="alert-link">Discord Server</a>.
    </div>
     <Container fluid>
      <Row>
       <Card style={{ width: '100%' }}>
  <Card.Header>Orders</Card.Header>
  <Card.Body>
    <Card.Title>Place and manage orders.</Card.Title>
    <Card.Text>
      Here you can see all the orders you have placed, the status of those orders or even place new orders.
    </Card.Text>
    <Button variant="primary" href="https://premium-studios.com/orders">Orders</Button>
  </Card.Body>
</Card>
 </Row>
</Container>
<Container fluid>
  <Row>
<Card style={{ width: '100%' }}>
  <Card.Header>Bots</Card.Header>
  <Card.Body>
    <Card.Title>Manage your Bots.</Card.Title>
    <Card.Text>
      Here you can manage your bots that have been made by us, if your bot is not on here then you need to make a ticket in our server.
    </Card.Text>
    <Button variant="primary" href="https://premium-studios.com/bot">Bots</Button>
  </Card.Body>
</Card>
        </Row>
      </Container>
       </Container>
      <Footer />
      <Modal
        show={props.showModal}
        user={props.user}
        onHide={props.closeModal}
        onSubmit={props.submitNewOrder}
        newOrder={props.newOrder}
        onChange={props.onChange}
        formSubmitting={props.formSubmitting}
      />
      {props.alert && <SweetAlert {...props.alert} />}
    </div>
  )

export default PanelView



// WEBPACK FOOTER //
// ./src/routes/page/PanelView.js